/* acaciasupplies — base.js
   Two jobs, no dependencies: section label numbering and the honeypot guard
   for email forms. Nothing else belongs here. The scroll reveal left with S39
   (25 sep 2026): all motion lives in motion.css / motion.js.
   Los relojes del header salieron con el relay v2: el header es logotipo y
   menú, nada más. */
(function () {
  'use strict';

  /* ── Section numbers ───────────────────────────────────────────────────
     Sections with no content render nothing, so their template numbers
     would leave gaps (01, 02, 04). Renumber what is on the page, in order. */
  function initLabelNumbers() {
    var numbers = document.querySelectorAll('main [data-label-n]');
    Array.prototype.forEach.call(numbers, function (node, index) {
      var value = index + 1;
      node.textContent = value < 10 ? '0' + value : String(value);
    });
  }

  /* ── Honeypot ──────────────────────────────────────────────────────────
     Any form[data-honeypot] whose .hp field has a value is not submitted. */
  function initHoneypot() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-honeypot')) return;

      var trap = form.querySelector('.hp input');
      if (trap && trap.value.trim() !== '') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  initLabelNumbers();
  initHoneypot();
})();
